import { Box, Stack, Typography } from '@mui/material'
import { FC } from 'react'
import { Deal, Product } from 'types'
import { formatDateString } from 'utils/formatDayjsDateTime'

interface CreateNewDealDisclaimerProps {
  newDeal: Deal
  selectedDeal: Deal
  relatedProducts: Product[]
}

const CreateDealDisclaimer: FC<CreateNewDealDisclaimerProps> = ({ newDeal, selectedDeal, relatedProducts }) => {
  return (
    <Stack
      sx={{
        position: 'fixed',
        top: 75,
        left: '90%',
        transform: 'translateX(-70%)',
        backgroundColor: 'background.input',
        color: 'white',
        padding: 2,
        borderRadius: 2,
        boxShadow: 6,
        zIndex: 1402,
        minWidth: 300,
        textAlign: 'left',
        gap: 1,
      }}
    >
      {[
        { label: 'Deal Name', value: newDeal?.name ?? '', color: 'text.subtask' },
        { label: 'Product Count', value: relatedProducts?.length ?? 0 },
        { label: 'Type', value: newDeal?.type ?? '' },
        { label: 'Start Date', value: newDeal?.startDate ? formatDateString(newDeal?.startDate) : '', color: '' },
        { label: 'End Date', value: newDeal?.endDate ? formatDateString(newDeal?.endDate) : '', color: '' },
        { label: 'Cloning From', value: selectedDeal?.name ?? '', color: '' },
      ].map(({ label, value, color }) => (
        <Box
          key={label}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 0.25,
            width: '100%',
          }}
        >
          <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>
            {label}
          </Typography>
          <Typography sx={{ wordBreak: 'break-word', color: color ?? 'text.primary' }}>{value || '—'}</Typography>
        </Box>
      ))}
      <Typography sx={{ fontSize: 13, color: 'text.warning', mt: 1 }}>
        Once an existing deal is selected for clone & replace, that deal can no longer be cloned again
      </Typography>
    </Stack>
  )
}
export default CreateDealDisclaimer
